/**
 *  文房 api 枚举
 */
export enum EnumApiStationery {
  // 文房列表
  Products = '/core/api/products',
  ProductsV2 = '/product/api/wenfang/product',
  ProductDetailById = '/product/api/wenfang/product/byids'
}
